import { get } from '@ember/object';
import Mixin from '@ember/object/mixin';
import { scheduleOnce } from '@ember/runloop';
import { service } from '@ember/service';
import { reset, setupRouter } from 'ember-app-scheduler';

// this overrides the mixin from ember-router-scroll
// and takes into consideration ember-burger-menu
export default Mixin.create({
  deRouterScroll: service(),

  init() {
    this._super(...arguments);

    setupRouter(this);

    this.on('routeWillChange', () => {
      this.deRouterScroll.update();
    });
    this.on('routeDidChange', (transition) => {
      scheduleOnce('render', this, () => this.updateScrollPosition(transition));
    });
  },

  destroy() {
    reset();

    this._super(...arguments);
  },

  updateScrollPosition(transition) {
    let scrollPosition = this.deRouterScroll.position;

    let preserveScrollPosition = (
      transition.router.currentRouteInfos ?? []
    ).some((routeInfo) =>
      get(routeInfo, 'route.controller.preserveScrollPosition'),
    );

    if (!preserveScrollPosition) {
      let bmContent = document.querySelector('.bm-content');
      if (bmContent) {
        bmContent.scrollTop = scrollPosition.y;
      }
    }
  },
});
